import { render } from "./ProjectForm.vue?vue&type=template&id=151f4fa2"
import script from "./ProjectForm.vue?vue&type=script&lang=js"
export * from "./ProjectForm.vue?vue&type=script&lang=js"
script.render = render

export default script